import { CompanyTheme } from '../../api/types';
import DayjsRangePicker from '../../components/DayjsRangePicker';
import CheckboxField from '../../components/fields/CheckboxField';
import PhoneAndPrefixField from '../../components/fields/ci/PhoneField';
import CountryField from '../../components/fields/CountryField';
import DatePickerField from '../../components/fields/DatePickerField';
import DisplayField from '../../components/fields/DisplayField';
import DisplayFieldWithUTCOffset from '../../components/fields/DisplayFieldWithUTCOffset';
import FixedRangePickerField from '../../components/fields/FixedRangePickerField';
import GenderField from '../../components/fields/GenderField';
import IdentityNumberField from '../../components/fields/IdentityNumberField';
import InputNumberField from '../../components/fields/InputNumberField';
import MaritalStatusField from '../../components/fields/MaritalStatusField';
import MultipleDraggerField from '../../components/fields/MultipleDraggerField';
import NationalityField from '../../components/fields/NationalityField';
import RaceField from '../../components/fields/RaceField';
import RangePickerField from '../../components/fields/RangePickerField';
import RegionField from '../../components/fields/RegionField';
import ResidentialStatusField from '../../components/fields/ResidentialStatusField';
import SelectField from '../../components/fields/SelectField';
import SwitchField from '../../components/fields/SwitchField';
import TimePickerField from '../../components/fields/TimePickerField';
import TranslatedInputField from '../../components/fields/TranslatedInputField';
import VehicleCarousel from '../../components/Images';
import PaginatedTableWithContext from '../../components/PaginatedTableWithContext';
import TimePicker from '../../components/TimePickerField';
import type { ThemeComponents } from '../context';
import makeThemeComponents from '../makeThemeComponents';
import PorscheCarousel from '../porsche/Carousel';
import CheckboxGroup from '../volkswagen/CheckboxGroup';
import ConfiguratorDropdown from '../volkswagen/Configurator/Dropdown';
import Anchor from './Anchor';
import ArrowDownIcon from './ArrowDownIcon';
import BackButton from './BackButton';
import Button from './Button';
import Calculator from './Calculator';
import CardWithHeader from './CardWithHeader';
import Checkbox from './Checkbox';
import CloseButton from './CloseButton';
import ComparisonButton from './ComparisonButton';
import ConfiguratorDepositDisplay from './Configurator/DepositDisplay';
import ConfiguratorLayout from './Configurator/Layout';
import ConfiguratorMessageButton from './Configurator/MessageButton';
import ConfiguratorSubHeader from './Configurator/SubHeader';
import ConsentModal from './ConsentModal';
import LegalText from './ConsentsAndDeclarations/LegalText';
import DefaultGlobalStyles from './DefaultGlobalStyles';
import Dropdown from './Dropdown';
import ErrorMessageBox from './ErrorMessageBox';
import InputField from './Fields/InputField';
import PasswordField from './Fields/PasswordField';
import FinderLayout from './Finder/Layout';
import InfoMessageBox from './InfoMessageBox';
import Input from './Input';
import JourneySteps from './JourneySteps';
import ListItem from './ListItem';
import LoadingSpinner from './LoadingSpinner';
import MobilityWebpageLayout from './Mobility/WebPageLayout';
import Modal from './Modal';
import notification from './notification';
import PageWithHeader from './PageWithHeader';
import Popconfirm from './Popconfirm';
import Radio from './Radio';
import Search from './Search';
import Select from './Select';
import StandardLayout from './Standard/Layout';
import Steps from './Steps';
import Tabs from './Tabs';
import Title from './Title';
import Tooltip from './Tooltip';
import WarningMessageBox from './WarningMessageBox';

const DefaultTheme: ThemeComponents = {
    theme: CompanyTheme.Default,
    gutter: {
        testDriveModal: [14, 14],
    },
    Input,
    PageWithHeader,
    Dropdown,
    ConfiguratorDropdown,
    Select,
    ConfiguratorLayout,
    ConfiguratorSubHeader,
    ConfiguratorMessageButton,
    ConfiguratorDepositDisplay,
    Button,
    Title,
    Checkbox,
    CheckboxGroup,
    RangePicker: DayjsRangePicker,
    StandardLayout,
    MobilityWebpageLayout,
    BackButton,
    CloseButton,
    ComparisonButton,
    FinderLayout,
    TimePicker,
    FormFields: {
        RangePickerField,
        FixedRangePickerField,
        SelectField,
        DatePickerField,
        InputField,
        InputNumberField,
        IdentityNumberField,
        NationalityField,
        PhoneAndPrefixField,
        RegionField,
        CountryField,
        MultipleDraggerField,
        TimePickerField,
        RaceField,
        GenderField,
        ResidentialStatusField,
        MaritalStatusField,
        CheckboxField,
        SwitchField,
        TranslatedInputField,
        DisplayField,
        PasswordField,
        DisplayFieldWithUTCOffset,
    },
    LoadingSpinner,
    Modal,
    ConsentModal,
    notification,
    Radio,
    RadioGroup: Radio.Group,
    CardWithHeader,
    Steps,
    Search,
    ErrorMessageBox,
    WarningMessageBox,
    JourneySteps,
    PaginatedTableWithContext,
    Popconfirm,
    Carousel: PorscheCarousel,
    InfoMessageBox,
    Tooltip,
    Calculator,
    ListItem,
    Tabs,
    Anchor,
    LegalText,
    ArrowDownIcon,
    VehicleCarousel,
};

export default makeThemeComponents('DefaultThemeProvider', DefaultTheme, DefaultGlobalStyles);
